import { theme, styled, mixins } from 'ui/theme';

const loaderOpacity = '0.8';

export const Loader = styled.svg`
  display: block;
  margin: ${theme.space[0]} auto;
`;

export const LoaderFullScreen = {
  Loader: styled('div')`
    height: ${theme.sizes[20]};
    width: ${theme.sizes[20]};

    svg {
      height: 100%;
      width: 100%;
    }
  `,

  Message: styled('span')`
    ${mixins.baseFont};
    margin-top: ${theme.space[2]};
  `,

  Wrapper: styled('div')`
    align-items: center;
    background: ${theme.colors.background.standard};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    opacity: ${loaderOpacity};
    position: fixed;
    top: 0;
    width: 100%;
    z-index: ${theme.zIndices.loading};
  `,
};
